const URLSearchParams = require('url-search-params')

const secondScreens = ['ContentDetails', 'UserDetails', 'AdminDetails', 'AlertDetails', 'SmsHistory']

/**
  * @func addQuery
  * @param {Object} q
  * @param {Object} location
  * @param {Object} navigate
*/
export const addQuery = (q, location, navigate) => {
  const query = new URLSearchParams(location.search)
  let empty = true
  if (q[Object.keys(q)[0]]) {
    query.set(Object.keys(q)[0], q[Object.keys(q)[0]])
    empty = false
  }
  if (q[Object.keys(q)[1]]) {
    query.set(Object.keys(q)[1], q[Object.keys(q)[1]])
    empty = false
  }
  if (empty) {
    query.delete(Object.keys(q)[0])
  }
  navigate({ pathname: location.pathname, search: query.toString() })
}

export const isSecondRoute = (routeName) => {
  return secondScreens.indexOf(routeName) !== -1
}
/**
  * @param {...String} queryNames
*/
// export const removeQuery = (...queryNames) => {
//     const location = Object.assign({}, browserHistory.getCurrentLocation());
//     queryNames.forEach(q => delete location.query[q]);
//     browserHistory.push(location);
// };
